import { render, staticRenderFns } from "./add-artist.vue?vue&type=template&id=6aae9c7c"
import script from "./add-artist.vue?vue&type=script&lang=js"
export * from "./add-artist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gobo-app/gobo-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6aae9c7c')) {
      api.createRecord('6aae9c7c', component.options)
    } else {
      api.reload('6aae9c7c', component.options)
    }
    module.hot.accept("./add-artist.vue?vue&type=template&id=6aae9c7c", function () {
      api.rerender('6aae9c7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/editEvent/add-artist.vue"
export default component.exports